import React from "react";

// Chakra imports
import { Flex, useColorModeValue, Image } from "@chakra-ui/react";

// Custom components
import { ReactComponent as Logo } from "assets/img/layout/logo.svg";
import { HorizonLogo } from "components/icons/Icons";
import { HSeparator } from "components/separator/Separator";

export function SidebarBrand() {
  //   Chakra color mode
  let logoColor = useColorModeValue("navy.700", "white");

  return (
    <Flex align='center' direction='column' mb='41px'>
      {/* <HorizonLogo h='26px' w='175px' my='32px' color={logoColor} /> */}
      <Logo color={logoColor} />
      {/* <HSeparator mb='2.85rem' /> */}
    </Flex>
  );
}

export default SidebarBrand;
